export default class EnumFormatter {
  constructor(enumOptions = null) {
    this.enumOptions = enumOptions;
  }

  format(filterValue, options = {}) {
    const enumOptions = options.enumOptions || this.enumOptions;
    return enumOptions[filterValue];
  }

  formatRange() {
    throw 'Enums cannot be defined in a range';
  }
}
